export const baseApiUrl = `${process.env.REACT_APP_BASE_URL}/admin`
const MASTER_DATA = 'master-data'

export const AUTHENTICATION_URLS = {
  login: `${baseApiUrl}/login`,
  forgotPassword: `${baseApiUrl}/forgot-password`,
  resetPassword: `${baseApiUrl}/reset-password`,
  getCurrentUser: `${baseApiUrl}/current`,
  checkPasswordResetToken: `${baseApiUrl}/reset-password`
}

const baseUserUrl = `${baseApiUrl}/users`
export const USER_URLS = {
  getAllUser: baseUserUrl,
  createUser: baseUserUrl,
  getUserById: (userId: string) => `${baseUserUrl}/${userId}`,
  updateUser: `${baseUserUrl}/info`,
  resetUserPassword: `${baseUserUrl}/password`,
  updateUserStatus: `${baseUserUrl}/status`
}

const baseRoleUrl = `${baseApiUrl}/roles`
export const ROLE_URLS = {
  getAllRole: baseRoleUrl,
  createRole: baseRoleUrl,
  getRoleById: (roleId: string) => `${baseRoleUrl}/${roleId}`,
  deleteRole: `${baseRoleUrl}/delete`,
  updateRoleInfo: `${baseRoleUrl}/info`,
  updateRolePermissions: `${baseRoleUrl}/permissions`,
  masterData: {
    getPermissionMasterData: `${baseRoleUrl}/permissions/${MASTER_DATA}`,
    getRoleMasterData: `${baseRoleUrl}/${MASTER_DATA}`
  }
}

const baseBannerUrl = `${baseApiUrl}/banners`
export const BANNER_URLS = {
  getAllBanner: baseBannerUrl,
  getAllBannerDetails: `${baseBannerUrl}/detail`,
  getBannerById: (bannerId: string) => `${baseBannerUrl}/detail/${bannerId}`,
  createBanner: baseBannerUrl,
  updateBanner: baseBannerUrl,
  deleteBanner: `${baseBannerUrl}/delete`
}

const basePopupUrl = `${baseApiUrl}/popups`
export const POPUP_URLS = {
  getAllPopups: basePopupUrl,
  getPopupById: (popupId: string) => `${basePopupUrl}/${popupId}`,
  createPopup: basePopupUrl,
  updatePopup: basePopupUrl,
  updatePopupOrder: `${basePopupUrl}/order`,
  deletePopup: `${basePopupUrl}/delete`
}

const basePageUrl = `${baseApiUrl}/pages`
export const PAGE_URLS = {
  getAllPages: basePageUrl,
  getPageTitleById: (pageId: string) => `${basePageUrl}/${pageId}/title`,
  getPageDescriptionById: (pageId: string) => `${basePageUrl}/${pageId}/description`,
  getPageStatusById: (pageId: string) => `${basePageUrl}/${pageId}/status`,
  getPageById: (pageId: string) => `${basePageUrl}/${pageId}`,
  createPage: basePageUrl,
  updatePage: basePageUrl,
  updatePageTitle: `${basePageUrl}/title`,
  updatePageDescription: `${basePageUrl}/description`,
  updatePageStatus: `${basePageUrl}/status`,
  deletePage: `${basePageUrl}/delete`
}

const baseProductUrl = `${baseApiUrl}/products`
export const PRODUCT_URLS = {
  getAllProducts: baseProductUrl,
  getProductById: (productId: string) => `${baseProductUrl}/${productId}`,
  createProduct: baseProductUrl,
  updateProduct: baseProductUrl,
  deleteProduct: `${baseProductUrl}/delete`,
  updateProductOrder: `${baseProductUrl}/order`
}

const baseBenefitUrl = `${baseApiUrl}/benefits`
export const BENEFIT_URLS = {
  getAllBenefits: baseBenefitUrl,
  createOrUpdateBenefits: baseBenefitUrl
}

const baseFAQUrl = `${baseApiUrl}/faqs`
export const FAQ_URLS = {
  getAllFAQs: baseFAQUrl,
  createOrUpdateFAQs: baseFAQUrl
}

const baseInsuranceUrl = `${baseApiUrl}/insurances`
const baseInsurerUrl = `${baseInsuranceUrl}/insurers`
export const INSURER_URLS = {
  getAllInsurer: baseInsurerUrl,
  exportInsurers: `${baseInsurerUrl}/export`,
  addInsurer: baseInsurerUrl,
  deleteInsurerById: `${baseInsurerUrl}/delete`,
  getInsurerInfo: (insurerId: string) => `${baseInsurerUrl}/${insurerId}/info`,
  getAllPlan: (insurerId: string) => `${baseInsurerUrl}/${insurerId}/plans`,
  getInsurerAgreement: (insurerId: string) => `${baseInsurerUrl}/${insurerId}/agreement`,
  updateInsurerInfo: `${baseInsurerUrl}/info`,
  updateInsurerAgreement: `${baseInsurerUrl}/agreement`,
  updatePlanOrder: `${baseInsurerUrl}/plans/order`,
  updateInsurerStatus: `${baseInsurerUrl}/status`,
  masterData: {
    getInsurerMasterData: `${baseInsurerUrl}/${MASTER_DATA}`
  }
}

const baseCustomerUrl = `${baseApiUrl}/customers`
const baseCustomerTransactionUrl = `${baseApiUrl}/customerTransactions`
export const CUSTOMER_URLS = {
  getAllCustomers: baseCustomerUrl,
  exportCustomers: `${baseCustomerUrl}/export`,
  addCustomer: baseCustomerUrl,
  getCustomerName: (customerId: string) => `${baseCustomerUrl}/${customerId}/name`,
  getCustomerStatus: (customerId: string) => `${baseCustomerUrl}/${customerId}/status`,
  getCustomerInfo: (customerId: string) => `${baseCustomerUrl}/${customerId}/info`,
  getCustomerContact: (customerId: string) => `${baseCustomerUrl}/${customerId}/contact`,
  getCustomerNote: (customerId: string) => `${baseCustomerUrl}/${customerId}/note`,
  getCustomerTimestamp: (customerId: string) => `${baseCustomerUrl}/${customerId}/timestamp`,
  updateCustomerStatus: `${baseCustomerUrl}/status`,
  updateCustomerInfo: `${baseCustomerUrl}/info`,
  updateCustomerContact: `${baseCustomerUrl}/contact`,
  updateCustomerNote: `${baseCustomerUrl}/note`,
  getAllTransactionByCustomerId: `${baseCustomerTransactionUrl}`,
  getCountTransactionByCustomerId: `${baseCustomerTransactionUrl}/count`,
  exportTransactionByCustomerId: `${baseCustomerTransactionUrl}/export`,
  getTransactionInsured: (transactionId: string) => `${baseCustomerTransactionUrl}/${transactionId}/insured`,
  getTransactionSummary: (transactionId: string) => `${baseCustomerTransactionUrl}/${transactionId}/summary`,
  getTransactionDetail: (transactionId: string) => `${baseCustomerTransactionUrl}/${transactionId}/detail`,
  updateTransactionInsured: `${baseCustomerTransactionUrl}/insured`,
  cancelInsured: `${baseCustomerTransactionUrl}/insured/cancel`,
  getTransactionTaxInvoiceByTransactionId: (transactionId: string) =>
    `${baseCustomerTransactionUrl}/${transactionId}/tax-invoice`,
  updateTransactionTaxInvoice: `${baseCustomerTransactionUrl}/tax-invoice`,
  updateSentTaxInvoice: `${baseCustomerTransactionUrl}/tax-invoice/sent`
}

const basePlanUrl = `${baseInsuranceUrl}/plans`
export const PLAN_URLS = {
  getAllPlans: basePlanUrl,
  exportPlans: `${basePlanUrl}/export`,
  downloadPlanTemplate: `${basePlanUrl}/template`,
  importPlanTemplate: `${basePlanUrl}/import`,
  addPlan: basePlanUrl,
  deletePlanById: `${basePlanUrl}/delete`,
  getPlanStatus: (planId: string) => `${basePlanUrl}/${planId}/status`,
  getPlanInfo: (planId: string) => `${basePlanUrl}/${planId}/info`,
  getPlanType: (planId: string) => `${basePlanUrl}/${planId}/type`,
  getPlanCountries: (planId: string) => `${basePlanUrl}/${planId}/countries`,
  getPlanPrices: (planId: string) => `${basePlanUrl}/${planId}/prices`,
  getPlanSpecialLabel: (planId: string) => `${basePlanUrl}/${planId}/special-label`,
  getPlanDetail: (planId: string) => `${basePlanUrl}/${planId}/detail`,
  getPlanException: (planId: string) => `${basePlanUrl}/${planId}/exception`,
  getPlanTimestamp: (planId: string) => `${basePlanUrl}/${planId}/timestamp`,
  updatePlanStatus: `${basePlanUrl}/status`,
  updatePlanInfo: `${basePlanUrl}/info`,
  updatePlanType: `${basePlanUrl}/type`,
  updatePlanCountries: `${basePlanUrl}/countries`,
  updatePlanPrices: `${basePlanUrl}/prices`,
  updatePlanSpecialLabel: `${basePlanUrl}/special-label`,
  updatePlanDetail: `${basePlanUrl}/detail`,
  updatePlanException: `${basePlanUrl}/exception`,
  downloadCountryTemplate: `${basePlanUrl}/countries/template`,
  getCountryIdListFromExcel: `${basePlanUrl}/countries/list`,
  exportPlanCountryById: (planId: string) => `${basePlanUrl}/${planId}/countries/export`,
  downloadPriceTemplate: `${basePlanUrl}/prices/template`,
  getPriceListFromExcel: `${basePlanUrl}/prices/list`,
  exportPlanPriceById: (planId: string) => `${basePlanUrl}/${planId}/prices/export`,
  masterData: {}
}

const baseDealerMasterUrl = `${baseApiUrl}/dealers`
const baseDealerMasterTransactionUrl = `${baseApiUrl}/dealerTransactions`
export const DEALER_MASTER_URLS = {
  createDealer: baseDealerMasterUrl,
  deleteDealer: `${baseDealerMasterUrl}/delete`,
  getAllDealers: baseDealerMasterUrl,
  exportDealers: `${baseDealerMasterUrl}/export`,
  getDealerInfoById: (dealerId: string) => `${baseDealerMasterUrl}/${dealerId}/info`,
  getDealerColorCode: (dealerId: string) => `${baseDealerMasterUrl}/${dealerId}/colorCode`,
  getDealerAddress: (dealerId: string) => `${baseDealerMasterUrl}/${dealerId}/address`,
  getDealerRemark: (dealerId: string) => `${baseDealerMasterUrl}/${dealerId}/remark`,
  getDealerStatus: (dealerId: string) => `${baseDealerMasterUrl}/${dealerId}/status`,
  updateDealerInfo: `${baseDealerMasterUrl}/info`,
  updateDealerColorCode: `${baseDealerMasterUrl}/colorCode`,
  updateDealerAddress: `${baseDealerMasterUrl}/address`,
  updateDealerRemark: `${baseDealerMasterUrl}/remark`,
  updateStatusDealer: `${baseDealerMasterUrl}/status`,
  countTransaction: `${baseDealerMasterTransactionUrl}/count`,
  getAllDealerTransactions: baseDealerMasterTransactionUrl,
  exportDealerTransactions: `${baseDealerMasterTransactionUrl}/export`,
  getTransactionInsured: (transactionId: string) => `${baseDealerMasterTransactionUrl}/${transactionId}/insured`,
  getTransactionSummary: (transactionId: string) => `${baseDealerMasterTransactionUrl}/${transactionId}/summary`,
  getTransactionDetail: (transactionId: string) => `${baseDealerMasterTransactionUrl}/${transactionId}/detail`,
  updateTransactionInsured: `${baseDealerMasterTransactionUrl}/insured`,
  cancelInsured: `${baseDealerMasterTransactionUrl}/insured/cancel`,
  getTransactionCommission: (transactionId: string) => `${baseDealerMasterTransactionUrl}/${transactionId}/commission`,
  getTransactionTaxInvoiceByTransactionId: (transactionId: string) =>
    `${baseDealerMasterTransactionUrl}/${transactionId}/tax-invoice`,
  updateTransactionTaxInvoice: `${baseDealerMasterTransactionUrl}/tax-invoice`,
  updateSentTaxInvoice: `${baseDealerMasterTransactionUrl}/tax-invoice/sent`
}

const baseCommissionUrl = `${baseApiUrl}/commissions`
export const COMMISSION_URLS = {
  getAllCommissions: baseCommissionUrl,
  exportCommissions: `${baseCommissionUrl}/export`,
  getCommissionDealerInfo: (dealerId: string) => `${baseCommissionUrl}/${dealerId}/info`,
  getCommissionByDealerId: (dealerId: string) => `${baseCommissionUrl}/${dealerId}`,
  createCommission: baseCommissionUrl,
  updateCommission: baseCommissionUrl,
  deleteCommission: `${baseCommissionUrl}/delete`,
  getCommissionTransactionsByDealerId: (dealerId: string) => `${baseCommissionUrl}/${dealerId}/transactions`,
  updateStatusCommissionTransactions: `${baseCommissionUrl}/transactions/status`,
  getCommissionSummaryByDealerId: (dealerId: string) => `${baseCommissionUrl}/${dealerId}/summary`,
  saveCommissionSummary: `${baseCommissionUrl}/summary/save`,
  approveCommissionSummary: `${baseCommissionUrl}/summary/approve`,
  importCommission: `${baseCommissionUrl}/import`,
  downloadCommissionTemplate: `${baseCommissionUrl}/template`
}

const baseTransactionUrl = `${baseApiUrl}/transactions`
export const TRANSACTION_URLS = {
  getAllTransactions: baseTransactionUrl,
  exportTransactions: `${baseTransactionUrl}/export`,
  createTransaction: baseTransactionUrl,
  updateTransactionPerCustomer: baseTransactionUrl,
  cancelTransactionPerCustomer: `${baseTransactionUrl}/cancel`,
  calculatePrice: `${baseTransactionUrl}/calculatePrice`,
  downloadCustomerTemplate: `${baseTransactionUrl}/customers/template`,
  getCustomerListFromExcel: `${baseTransactionUrl}/customers/list`,
  exportTransactionCustomers: (transactionId: string) => `${baseTransactionUrl}/${transactionId}/customers/export`,
  getTravelDetail: (transactionId: string) => `${baseTransactionUrl}/${transactionId}/travelDetail`,
  getInsurancePlan: (transactionId: string) => `${baseTransactionUrl}/${transactionId}/insurancePlan`,
  getCustomers: (transactionId: string) => `${baseTransactionUrl}/${transactionId}/customers`,
  getPrice: (transactionId: string) => `${baseTransactionUrl}/${transactionId}/price`,
  getCustomerDetail: (transactionId: string, customerId: string) =>
    `${baseTransactionUrl}/${transactionId}/customers/${customerId}`,
  searchCustomerExcel: `${baseTransactionUrl}/customers/searchCustomerExcel`,
  getInsurers: `${baseTransactionUrl}/insurers`,
  getPlans: `${baseTransactionUrl}/plans`,
  getTransactionTimestamp: (transactionId: string) => `${baseTransactionUrl}/${transactionId}/timestamp`,
  getTransactionStatus: (transactionId: string) => `${baseTransactionUrl}/${transactionId}/status`,
  getIntegrationMessage: (transactionId: string) => `${baseTransactionUrl}/${transactionId}/integration/message`,
  updateTransactionStatus: `${baseTransactionUrl}/status`
}

const basePromotionUrl = `${baseApiUrl}/promotions`
export const PROMOTION_URLS = {
  getAllPromotions: basePromotionUrl,
  getAllInsurancePlans: `${basePromotionUrl}/plans`,
  exportPromotions: `${basePromotionUrl}/export`,
  exportPromoCodes: (promotionId: string) => `${basePromotionUrl}/${promotionId}/promoCodes/export`,
  createPromotion: basePromotionUrl,
  updatePromotion: basePromotionUrl,
  updatePromotionStatus: `${basePromotionUrl}/status`,
  getPromotionDetail: (promotionId: string) => `${basePromotionUrl}/${promotionId}/promotionDetail`,
  getDiscountDetail: (promotionId: string) => `${basePromotionUrl}/${promotionId}/discountDetail`,
  getAllPromotionInsurancePlans: (promotionId: string) => `${basePromotionUrl}/${promotionId}/insurancePlans`,
  getAllPromotionCodes: (promotionId: string) => `${basePromotionUrl}/${promotionId}/promotionCodes`,
  getPromotionDealerDetail: (promotionId: string) => `${basePromotionUrl}/${promotionId}/dealer`
}

export const MASTER_DATA_URLS = {
  getAllRegions: `${baseApiUrl}/regions`,
  getAllCountries: `${baseApiUrl}/countries`,
  getProvinceMasterData: `${baseApiUrl}/provinces/${MASTER_DATA}`,
  getDistrictMasterData: `${baseApiUrl}/districts/${MASTER_DATA}`,
  getSubDistrictMasterData: `${baseApiUrl}/sub-districts/${MASTER_DATA}`,
  getNationalityMasterData: `${baseApiUrl}/nationalities/${MASTER_DATA}`,
  getPrefixMasterData: `${baseApiUrl}/prefixes/${MASTER_DATA}`,
  getBeneficiariesMasterData: `${baseApiUrl}/beneficiaries/${MASTER_DATA}`,
  getFlightsMasterData: `${baseApiUrl}/flights/${MASTER_DATA}`,
  getOccupationsMasterData: `${baseApiUrl}/occupations/${MASTER_DATA}`,
  getDealerMasterData: `${baseApiUrl}/dealers/${MASTER_DATA}`
}

const baseUploadUrl = `${baseApiUrl}/upload`
export const UPLOAD_URLS = {
  uploadImage: `${baseUploadUrl}/image`,
  uploadFile: `${baseUploadUrl}/file`
}
